import { EntityList } from '@avangard/utils/entity';

import { SoaDocumentFileEntity } from './soa-document-file.entity';

import type { Entity } from './soa-document.entity';

class SoaDocumentFileEntityList extends EntityList<SoaDocumentFileEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(SoaDocumentFileEntity, items, count);
    }
}

export { SoaDocumentFileEntityList };
